import * as ko from 'knockout';
import * as $ from "jquery";

/**
 * Enterkey binding parameters.
 */
interface BindingContext {
    // Callback function which is executed on enterkey press
    callback: Function,
    // Args for the callback function
    args: Array<any>,
    // Event which should be triggered on enterkey press
    event: string
}

/**
 * A custom binding handler for 'Enter' keypress events to execute a callback function and pass an array of parameters to the callback.
 * If a event is passed the event is triggered before the callback is executed.
 * eg: <input type="text" data-bind="textInput:itemName, enterkey: { callback: addCategoryItem, args: [tripId, categoryId], event: 'blur' }">
 */
class EnterkeyBinding implements KnockoutBindingHandler {
    init (element: Node, valueAccessor: () => BindingContext, allBindings: KnockoutAllBindingsAccessor, viewModel: any) {
        const params = ko.unwrap(valueAccessor());
        const callback = params.callback ? params.callback : null;
        const args = params.args ? params.args : [];
        const event = params.event ? params.event : null;
        $(element).on( 'keypress', function (keyEvent) {
            const keyCode = (keyEvent.which ? keyEvent.which : keyEvent.keyCode);
            if (keyCode === 13) {
                if(event != null) {
                    $(element).trigger(event);
                }
                if(callback != null) {
                    callback.apply(viewModel, args);
                }
                return false;
            }
            return true;
        });
    }
}

export default new EnterkeyBinding();